import React, { useId, useState } from "react";
import InfoIcon from "../InfoIcon";
import { typography, textColors, surfaces, borders } from "../../../design-system/tokens";

export const TextField = ({ value, onChange, label, help, multiline, infoText, placeholder }) => {
  const inputId = useId();
  const [isFocused, setIsFocused] = useState(false);

  const baseClasses = `
    w-full px-4 py-2.5 rounded-xl
    ${surfaces.primary} ${borders.default} border
    ${typography.body} ${textColors.primary}
    placeholder:text-gray-400 dark:placeholder:text-gray-500
    focus:outline-none focus:ring-2 focus:ring-blue-500/30 dark:focus:ring-blue-400/30
    focus:border-blue-500 dark:focus:border-blue-400
    transition-all duration-200
  `;

  return (
    <div className="field-wrapper">
      {label && (
        <label
          htmlFor={inputId}
          className={`block mb-2 ${typography.label} ${isFocused ? "text-blue-600 dark:text-blue-400" : textColors.secondary} transition-colors duration-200`}
        >
          {label}
          {infoText ? (
            <span className="ml-2 align-middle">
              <InfoIcon text={infoText} />
            </span>
          ) : null}
        </label>
      )}
      {multiline ? (
        <textarea
          id={inputId}
          aria-label={label}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          rows={4}
          placeholder={placeholder || ""}
          className={baseClasses}
        />
      ) : (
        <input
          type="text"
          id={inputId}
          aria-label={label}
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          placeholder={placeholder || ""}
          className={baseClasses}
        />
      )}
      {help && <div className={`mt-1.5 ${typography.caption} ${textColors.tertiary}`}>{help}</div>}
    </div>
  );
};
